"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragLayerComponent = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_dnd_1 = require("react-dnd");
var ContentDragPreview_1 = require("./DragLayerPreview/ContentDragPreview");
var HeightResizerDragPreview_1 = require("./DragLayerPreview/HeightResizerDragPreview");
var WidthResizerDragPreview_1 = require("./DragLayerPreview/WidthResizerDragPreview");
var useScrollCorrection_1 = require("./Resize/useScrollCorrection");
var types_1 = require("./types");
var constants_1 = require("../layout/constants");
var LayoutResizeContext_1 = require("./LayoutResizeContext");
var constants_2 = require("../constants/");
var previewComponentsMap = {
    "internal-height-resizer": HeightResizerDragPreview_1.HeightResizerDragPreview,
    "internal-width-resizer": WidthResizerDragPreview_1.WidthResizerDragPreview,
};
exports.DragLayerComponent = function () {
    var dragLayerRef = react_1.useRef(null);
    var setScrollCorrection = LayoutResizeContext_1.useResizeHandlers().setScrollCorrection;
    var dragLayerProperties = react_dnd_1.useDragLayer(function (monitor) { return ({
        item: monitor.getItem(),
        itemType: monitor.getItemType(),
        clientOffset: monitor.getClientOffset(),
        currentOffset: monitor.getSourceClientOffset(),
        initialOffset: monitor.getInitialSourceClientOffset(),
        differenceFromInitialOffset: monitor.getDifferenceFromInitialOffset(),
        isDragging: monitor.isDragging(),
    }); });
    var itemType = dragLayerProperties.itemType, isDragging = dragLayerProperties.isDragging;
    var getDragLayerPosition = react_1.useCallback(function () {
        var _a, _b;
        return (_b = (_a = dragLayerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) !== null && _b !== void 0 ? _b : constants_1.emptyDOMRect;
    }, [dragLayerRef.current]);
    var isResizing = itemType === "internal-height-resizer" || itemType === "internal-width-resizer";
    var scrollCorrection = useScrollCorrection_1.useScrollCorrection(getDragLayerPosition, isDragging && isResizing).scrollCorrection;
    react_1.useEffect(function () {
        setScrollCorrection(scrollCorrection);
    }, [scrollCorrection, setScrollCorrection]);
    var layerStyles = react_1.useMemo(function () {
        var position = isResizing ? "relative" : "fixed";
        return {
            position: position,
            pointerEvents: "none",
            zIndex: constants_2.DASHBOARD_HEADER_OVERLAYS_Z_INDEX + 1,
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
        };
    }, [isResizing]);
    if (!isDragging) {
        return null;
    }
    var Component = types_1.isDraggableInternalItemType(itemType)
        ? previewComponentsMap[itemType]
        : ContentDragPreview_1.ContentDragPreview;
    var previewProps = types_1.isDraggableInternalItemType(itemType)
        ? tslib_1.__assign(tslib_1.__assign({}, dragLayerProperties), { getDragLayerPosition: getDragLayerPosition, scrollCorrection: scrollCorrection }) : dragLayerProperties;
    return (react_1.default.createElement("div", { className: "drag-layer", style: layerStyles, ref: dragLayerRef },
        react_1.default.createElement(Component, tslib_1.__assign({}, previewProps))));
};
//# sourceMappingURL=DragLayer.js.map